import React, { useEffect, useRef, useState } from "react";
import Dropdown from "../../input/Dropdown";
import { AUTH_TYPES, FORMS, MODULES } from "../../../const";
import ButtonRenderer from "../../renderer/ButtonRenderer";
import { ImMinus } from "react-icons/im";
import Grid from "../../Grid";
import { FaPlus, FaSave } from "react-icons/fa";
import Button from "../../input/Button";
import { toast } from "react-toastify";
import CustomAlert from "../../input/CustomAlert";

const BulkRate = ({
  vehicleContainerType,
  vehConList,
  calcType,
  saveRates,
}) => {
  const [selectedVehCons, setSelectedVehCons] = useState([]);
  const [rates, setRates] = useState([]);
  const [count, setCount] = useState(1);

  const [vehConTypeOpt, setVehConTypeOpt] = useState([]);

  const bulkSaveRef = useRef(null);

  useEffect(() => {
    const vehCons = Object.entries(vehConList).map(([key, value]) => ({
      key: parseInt(key),
      value: parseInt(key),
      text: value,
    }));
    setVehConTypeOpt(vehCons);
  }, [vehConList]);

  const addRates = () => {
    if (calcType === 1 && rates.length >= 1) {
      toast.warn("You can only add a single rate for flat calc type.", {
        autoClose: 5000,
        containerId: "Modal",
      });
      return;
    }
    setRates((prevState) => [
      ...prevState,
      {
        id: count,
        start: 0,
        end: 0,
        min: 0,
        rate: 0,
      },
    ]);
    setCount((prevState) => prevState + 1);
  };

  const cellEditorParams = (params) => {
    let value = params.value ? Math.abs(Number(params.value)) : 0;
    switch (params.colDef.field) {
      case "start":
        setRates((prev) =>
          prev.map((row) => {
            if (row.id === params.data.id) {
              if (row.persisted) {
                return {
                  ...row,
                  start: value,
                };
              } else {
                return {
                  ...row,
                  start: value,
                };
              }
            }
            return row;
          }),
        );
        break;
      case "end":
        setRates((prev) =>
          prev.map((row) => {
            if (row.id === params.data.id) {
              if (row.persisted) {
                return {
                  ...row,
                  end: value,
                };
              } else {
                return {
                  ...row,
                  end: value,
                };
              }
            }
            return row;
          }),
        );
        break;
      case "min":
        setRates((prev) =>
          prev.map((row) => {
            if (row.id === params.data.id) {
              if (row.persisted) {
                return {
                  ...row,
                  min: value,
                };
              } else {
                return {
                  ...row,
                  min: value,
                };
              }
            }
            return row;
          }),
        );
        break;
      case "rate":
        setRates((prev) =>
          prev.map((row) => {
            if (row.id === params.data.id) {
              if (row.persisted) {
                return {
                  ...row,
                  rate: value,
                };
              } else {
                return {
                  ...row,
                  rate: value,
                };
              }
            }
            return row;
          }),
        );
        break;
      default:
        break;
    }
  };

  return (
    <>
      <CustomAlert
        ref={bulkSaveRef}
        message={`These rate will replace any existing rates for the selected ${vehicleContainerType === 1 ? "Vehicle" : "Container"} Types`}
        onAccept={() => {
          saveRates(selectedVehCons, rates);
        }}
      />
      <div className="ui form">
        <div className="ui segment">
          <div className="ui dividing header">Bulk Rate Creation</div>

          <Dropdown
            value={selectedVehCons}
            options={vehConTypeOpt}
            multiple={true}
            label={
              vehicleContainerType === 1
                ? "Select Vehicles Types"
                : "Select Container Types"
            }
            onChange={(e, data) => {
              setSelectedVehCons(data.value);
            }}
          />
          <Button
            authenticated={true}
            editMode={false}
            module={MODULES.Finance}
            form={FORMS.RATE_MANAGER.DETAILS.form}
            onClick={addRates}
            Icon={FaPlus}
            label={"Add"}
            disabled={calcType === 1 && rates.length >= 1}
          />
          <Grid
            module={MODULES.Finance}
            searchable={false}
            stopEditingWhenCellsLoseFocus={true}
            onCellEditingStopped={cellEditorParams}
            config={[
              {
                headerName: "Start",
                field: "start",
                module: MODULES.Finance,
                primaryForm: FORMS.RATE_MANAGER.DETAILS.form,
                authenticated: true,
                cellEditorFramework: "agNumberCellEditor",
                editable: true,
                tooltipValueGetter: (params) => {
                  return "press Enter to set the value";
                },
                cellStyle: (params) => {
                  if (params.value < 0) {
                    return {
                      background: "red",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    };
                  } else {
                    return {
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    };
                  }
                },
              },
              {
                headerName: "End",
                field: "end",
                module: MODULES.Finance,
                primaryForm: FORMS.RATE_MANAGER.DETAILS.form,
                authenticated: true,
                cellEditor: "agNumberCellEditor",
                editable: true,
                tooltipValueGetter: (params) => {
                  return "press Enter to set the value";
                },
                cellStyle: (params) => {
                  if (params.value < 0) {
                    return {
                      background: "red",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    };
                  } else {
                    return {
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    };
                  }
                },
              },
              {
                headerName: "Min",
                field: "min",
                module: MODULES.Finance,
                primaryForm: FORMS.RATE_MANAGER.DETAILS.form,
                authenticated: true,
                cellEditor: "agNumberCellEditor",
                editable: true,
                tooltipValueGetter: (params) => {
                  return "press Enter to set the value";
                },
                cellStyle: (params) => {
                  if (params.value < 0) {
                    return {
                      background: "red",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    };
                  } else {
                    return {
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    };
                  }
                },
                valueFormatter: (params) => {
                  const value = params.value || 0;
                  return value.toFixed(2); // Always display with 2 decimal places
                },
              },
              {
                headerName: "Rate",
                field: "rate",
                module: MODULES.Finance,
                primaryForm: FORMS.RATE_MANAGER.DETAILS.form,
                authenticated: true,
                cellEditor: "agNumberCellEditor",
                editable: true,
                tooltipValueGetter: (params) => {
                  return "press Enter to set the value";
                },
                cellStyle: (params) => {
                  if (params.value < 0) {
                    return {
                      background: "red",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    };
                  } else {
                    return {
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    };
                  }
                },
                valueFormatter: (params) => {
                  const value = params.value || 0;
                  return value.toFixed(2);
                },
              },
              {
                field: "Action",
                width: "400px",
                cellRenderer: ButtonRenderer,
                cellRendererParams: (params) => ({
                  consider: AUTH_TYPES.CREATE,
                  clickHandler: () => {
                    setRates((prevState) =>
                      prevState.filter((ra) => ra.id !== params.data.id),
                    );
                  },
                  Icon: ImMinus,
                  className: "ui red button",
                  authenticated: true,
                  form: FORMS.RATE_MANAGER.DETAILS.form,
                  module: MODULES.Finance,
                  editMode: false,
                }),
              },
            ]}
            content={rates}
          />
          <div style={{ width: "100%", height: "30px", marginTop: "10px" }}>
            <Button
              authenticated={true}
              editMode={false}
              module={MODULES.Finance}
              form={FORMS.RATE_MANAGER.DETAILS.form}
              onClick={() => {
                if (calcType === 1) {
                  bulkSaveRef.current?.openAlert();
                } else {
                  saveRates(selectedVehCons, rates);
                }
              }}
              disabled={rates.length === 0 || selectedVehCons.length === 0}
              Icon={FaSave}
              label={"Save"}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default BulkRate;
